/* tslint:disable */
import { AgreementsModel, DetailAgreement } from './agreements.model';
import { AppInfoModel } from './app-info.model';
import { IBasciModel } from './basicModel/basic.model';
import { ClientProductModel } from './client-products.model';
import { BytteConfigType, CheckboxModel, DSBMobileConfig, OptionRadioModel } from './common.model';
import { AddressModel, ContactModel } from './contact.model';
import { DeviceInfoModel } from './device-info.model';
import { DocumentModel } from './document.model';

import { DomicilioModel } from './domicilio.model';
import { ErrorDateModel } from './error-date.model';
import { ErrorModel } from './error.model';
import { FiModel, FiModelSecondHeadline } from './fi.model';
import { ListsModel } from './lists.model';
import { LiveAbroadModel, ObjectCheckModel } from './live-abroad.model';
import { LogDeviceModel } from './log-device.model';
import { OccupationModel } from './occupation.model';
import { PhotosModel } from './photos.model';
import { PldModel } from './pld.model';
import { IProductsModel } from './products.model';
import { TermsModel } from './terms.model';
import { TransactionInfoModel } from './transaction.model';


export class OtherSimulationDataModel {
  code: string;
  product_type: string;
  sub_product: string;
  linea: string;
  name: ''
}

export class OtherEvidenteDataModel {
  firstname: string;
  middlename: string;
  primary_lastname: string;
  second_lastname: string;
  document_type: string;
  document_number: string;
  birthdate: string;
  date_of_issue: string;
  sex: string;
  email: string;
  mobile_number: string;
}


export class OccupationSecondHeadlineModel {
  /**
   * Nombre de la ocupación
   *
   * *Occupation's name*
   *
   * @var {string} name
   */
  name: string;

  /**
   * Ícono de la ocupación
   *
   * *Occupation's icon*
   *
   * @var {string} icon
   */
  icon: string;

  /**
   * Estado de la ocupacion (verdadero o falso)
   *
   * *Occupation's state (true or false)*
   *
   * @var {boolean} active
   */
  active: boolean;

  /**
   * Selección del usuario de la ocupación
   *
   * *User´s occupation selection*
   *
   * @var {boolean} selected
   */
  selected: boolean;

  /**
   * Ingresos mínimos infligido de la ocupación
   *
   * *Occupation minimun Inflicted Incomes*
   *
   * @var {number} minimun_inflicted_incomes
   */
  minimun_inflicted_incomes: number;

  /**
   *
   * ciiu
   *
   * @var {string} ciiu
   */
  ciiu: string;


  /**
   * Identificación de la ocupación
   *
   * *Ocuppation's identificaction*
   *
   * @var {number} id
   */
  id: number;

  /**
   * Flujo de navegación de la ocupación
   * *Occupation's Flow navigation'
   *
   * @var {number} occupation_flow
   */
  occupation_flow: number;

  /**
   * Mesnaje de ingresos
   *
   * *Incomes Message*
   *
   * @var {string} incomes_msg
   */
  incomes_msg?: string;
}

/**
 * Inicializacion de la clase ConfigValues.
 * Uso en el componente ConfigurationValues.
 */
export class ConfigValuesModel {
  value_master?: number;
  value_visa?: number;
  value_visalf?: number;
}

export class advisorCodeModel {
  /**
   * Código del país
   *
   * *Country code of the city*
   *
   * @type {string} country_code
   */
  advisorCode: string;
}

/**
 * Inicialización de la clase CityModel, modelo de la ciudad
 *
 * *Set CityModel class, city's model*
 *
 * @type {class}
 */
export class CityModel {
  /**
   * Código del país
   *
   * *Country code of the city*
   *
   * @type {string} country_code
   */
  country_code: string;

  /**
   * Código de provincia de la ciudad
   *
   * *City province code*
   *
   * @type {number} province_code
   */
  province_code: number;

  /**
   * Código de provincia de la ciudad de nacimiento
   *
   * *City province code*
   *
   * @type {number} province_code
   */
  bp_province_code?: number;

  /**
   * Código de la ciudad
   *
   * *City code*
   *
   * @type {string} city_code
   */
  city_code: string;

  /**
   * Código de la ciudad
   *
   * *City code*
   *
   * @type {string} city_code
   */
  bp_city_code?: string;

  /**
   * Descripción de la ciudad
   *
   * *City description*
   *
   * @type {string} description
   */
  description: string;

    /**
   *  code of providence
   *
   * *providence code*
   *
   * @type {string} description
   */
  district_id?: string;

}
/**
 * Inicialización de la clase CreditParms, modelo de los parametros del credito
 *
 * *Set CreditParms class, CreditParms model*
 *
 * @type {class}
 */
export class CreditParms {
  /**
   * Valor solicitado por el cliente
   *
   * *value of maxAmountValue*
   *
   * @type {string} maxAmountValue
   */
  maxAmountValue: string;
  /**
   * Valor de las cuotas solicitadas por el cliente
   *
   * value of max period value*
   *
   * @type {number} maxPeriodValue
   */
  maxPeriodValue: number;
  /**
   * lista del valor de las tasas
   *
   * *Array of rates*
   *
   * @type {any} rateValue
   */
  rateValue: any;
}

/**
 * Inicialización de la clase HousingTypeModel, modelo del tipo de vivienda
 *
 * *Set HousingTypeModel class, city's model*
 *
 * @type {class}
 */
export class HousingTypeModel {
  /**
   * Código del tipo de vivienda
   *
   * *code of housing type*
   *
   * @type {string} housingId
   */
  housingId: string;

  /**
   * Código de provincia de la ciudad
   *
   * *City province code*
   *
   * @type {string} description
   */
  description: string;
}

/**
 * Inicialización de la clase CityModelAlt, modelo de ciudad alternativo
 *
 * *Set CityModelAlt class, alternative city model*
 *
 * @type {class}
 */
export class CityModelAlt {
  /**
   * Código del país
   *
   * *Country code of the city*
   *
   * @type {string} country_code
   */
  country_code?: string;
  /**
   * Código de provincia de la ciudad
   *
   * *City province code*
   *
   * @type {number} province_code
   */
  province_code: number;
  /**
   * Código de la ciudad
   *
   * *City code*
   *
   * @type {string} city_code
   */
  city_code: string;
  /**
   * Descripción de la ciudad
   *
   * *City description*
   *
   * @type {string} description
   */
  description: string;

}
/**
 * Inicialización de la clase EthnicGroupModel, modelo del estado civil
 *
 * *Set MaritalStatus class, ethnic's group model*
 *
 * @type {class}
 */
export class EthnicGroupModel {
  /**
   * Código del grupo etnico
   *
   * *ethnic group code*
   *
   * @type {number} ethnic_group_code
   */
  ethnic_group_code: number;

  /**
   * Descripcion del grupo etnico
   *
   * *ethnic group description*
   *
   * @type {string} ethnic_group_description
   */
  ethnic_group_description: string;

}

/**
 * Inicialización de la clase CountryModel, modelo del país
 *
 * *Set CountryModel class, country model*
 *
 * @type {class}
 */
export class CountryModel {
  /**
   * Código del país
   *
   * *Country code*
   *
   * @type {string} country_code
   */
  country_code: string;
  /**
   * Descripción del país
   *
   * *Country description*
   *
   * @type {string} description
   */
  description: string;
}

/**
 * Inicialización de la clase MaritalStatus, modelo del estado civil
 *
 * *Set MaritalStatus class, marital's status model*
 *
 * @type {class}
 */
export class MaritalStatusModel {
  /**
   * Código del estado civil
   *
   * *Marital status code*
   *
   * @type {number} marital_status_code
   */
  marital_status_code: number;

  /**
   * Descripcion del estado civil
   *
   * *Marital status description*
   *
   * @type {string} marital_status_description
   */
  marital_status_description: string;

}

/**
 * Inicialización de la clase MaritalStatus para segundo titular, modelo del estado civil
 * 
 * *Set SecondHeadline MaritalStatus class, marital's status model*
 * 
 * @type {class}
 */
export class MaritalStatusSecondHeadlineModel {
  /**
   * Código del estado civil segundo titular
   * 
   * *Marital status code*
   * 
   * @type {number} marital_status_code
   */
  marital_status_code: number;

  /**
   * Descripcion del estado civil
   * 
   * *Marital status description*
   * 
   * @type {string} marital_status_description
   */
  marital_status_description: string;

}

/**
 * Inicialización de la clase SecondHeadline, modelo que guarda info sobre un segundo titular
 *  
 * *Set SecondHeadline class, SecondHeadline's status model*
 * 
 * @type {class}
 */
export class SecondHeadlineModel {
  has_second_headline: boolean;
  has_incomes_second_headline: boolean | null;
}

export class BasicInfoSecondHeadlineModel {
  name_second_headline: string;
  lastname_second_headline: string;
  doc_type_second_headline: number;
  doc_number_second_headline: string;
  birthdate_second_headline: Date;
  expeditiondate_second_headline: Date;
  gender_second_headline: string;
}

export class ContactSecondHeadlineModel {
  /**
  * Número de teléfono de contácto del usuario
  * 
  * *User's contact mobile number*
  * 
  * @type {string} mobile_number
  */
  mobile_number: string;

  /**
   * Número de teléfono de trabajo de contácto del usuario
   * 
   * *User's contact mobile employment number*
   * 
   * @type {string} employment_number
   */
  employment_number: string;

  /**
   * Correo electrónico de contácto del usuario
   * 
   * *User's contact email*
   * 
   * @type {string} email
   */
  email: string;

  /**
   * Detalle de la dirección de contácto del usuario
   * 
   * *User's contact address details*
   * 
   * @type {string} address
   */
  address: AddressModel;
}



export class AccountSelectionModel {
  /**
   * Código del estado civil
   *
   * *Marital status code*
   *
   * @type {number} account_selection_code
   */
  account_selection_code: number;

  /**
   * Descripcion del estado civil
   *
   * *Marital status description*
   *
   * @type {string} account_selection_description
   */
  account_selection_description: string;

}

/**
 * Inicialización de la clase OfficeModel, modelo de la oficina
 *
 * *Set OfficeModel class, office's model*
 *
 * @type {class}
 */
export class OfficeModel {
  /**
   * Identificación de la ocupación
   *
   * *Id occupation*
   *
   * @type {number} occupation_id
   */
  occupation_id: number;

  /**
   * Nombre de la compañia
   *
   * *Company name*
   *
   * @type {string} company_name
   */
  company_name: string;

  /**
   * Nombre de entrada de la compañia
   *
   * *Company name input*
   *
   * @type {string} company_nameInput
   */
  company_nameInput: string;

  /**
   * Número de la oficina
   *
   * *Office's number*
   *
   * @type {string} office_number
   */
  office_number: string;

  /**
   * Dirección de la oficina
   *
   * *Office's address*
   *
   * @type {AddressModel} address
   */
  address: AddressModel;
}

/**
 * Inicialización de la clase OfficeSecondHeadlineModel, modelo de la oficina
 * 
 * *Set OfficeSecondHeadlineModel class, office's model*
 * 
 * @type {class}
 */
export class OfficeSecondHeadlineModel {
  /**
   * Identificación de la ocupación
   * 
   * *Id occupation*
   * 
   * @type {number} occupation_id
   */
  occupation_id: number;

  /**
   * Nombre de la compañia
   * 
   * *Company name*
   * 
   * @type {string} company_name
   */
  company_name: string;

  /**
   * Nombre de entrada de la compañia
   * 
   * *Company name input*
   * 
   * @type {string} company_nameInput
   */
  company_nameInput: string;

  /**
   * Número de la oficina
   * 
   * *Office's number*
   * 
   * @type {string} office_number
   */
  office_number: string;

  /**
   * Dirección de la oficina
   * 
   * *Office's address*
   * 
   * @type {AddressModel} address
   */
  address: AddressModel;
}

/**
 * Inicialización de la clase AgencyModel, modelo de la agencia
 *
 * *Set AgencyModel class, agency model*
 *
 * @type {class}
 */
export class AgencyModel {
  /**
   * Código del país de la agencia
   *
   * *Agency country code*
   *
   * @type {string} country_code
   */
  country_code: string;

  /**
   * Código de la ciudad de la agencia
   *
   * *Agency city code*
   *
   * @type {string} city_code
   */
  city_code: string;

  /**
  * Código de la agencia
  *
  * *Agency's code*
  *
  * @type {string} agency_code
  */
  agency_code: string;

  /**
   * Código de provincia de la agencia
   *
   * *Agency's City province code*
   *
   * @type {string} province_code
   */
  province_code: number;

  /**
   * Descripción de la agencia
   *
   * *Agency's description*
   *
   * @type {string} description
   */
  description: string;

  /**
   * Dirección de la agencia
   *
   * *Agency's address*
   *
   * @type {string} address
   */
  address: string;
}

/**
 * Inicialización de la clase CiiuModel, modelo de la actividad económica del usuario
 *
 * *Set CiiuModel class, economical activity user's model*
 *
 * @type {class}
 */
export class CiiuModel {
  /**
   * Código del sector de la actividad económica
   *
   * *Economical sector code*
   *
   * @type {number} sector_code
   */
  sector_code: number;

  /**
   * Título del sector de la actividad económica
   *
   * *Economical sector title*
   *
   * @type {string} ciiu
   */
  ciiu: string;



  /**
   * Descripción del sector de la actividad económica
   *
   * *Economical sector description*
   *
   * @type {string} description
   */
  description: string;

  /**
   * Descripción larga del sector de la actividad económica
   *
   * *Economical sector large description*
   *
   * @type {string} large_description
   */
  large_description: string;

  /**
   * Validación para continuar proceso
   *
   * *Validation to continue process*
   *
   * @type {boolean} next
   */
  next: boolean;
}

/**
 * Inicialización de la clase CiiuSecondModel, modelo de la actividad económica del usuario
 * 
 * *Set CiiuSecondModel class, economical activity user's model*
 *
 * @type {class}
 */
export class CiiuSecondModel {
  /**
   * Código del sector de la actividad económica
   * 
   * *Economical sector code*
   * 
   * @type {number} sector_code
   */
  sector_code: number;

  /**
   * Título del sector de la actividad económica
   * 
   * *Economical sector title*
   * 
   * @type {string} ciiu
   */
  ciiu: string;

  /**
   * Descripción del sector de la actividad económica
   * 
   * *Economical sector description*
   * 
   * @type {string} description
   */
  description: string;

  /**
   * Descripción larga del sector de la actividad económica
   * 
   * *Economical sector large description*
   * 
   * @type {string} large_description
   */
  large_description: string;

  /**
   * Validación para continuar proceso
   * 
   * *Validation to continue process*
   * 
   * @type {boolean} next
   */
  next: boolean;
}

/**
 * Inicialización de la clase ForeignCurrencyModel, modelo de moneda extrangera
 *
 * *Set ForeignCurrencyModel class, Foreign currency model*
 *
 * @type {class}
 */
export class ForeignCurrencyModel {
  /**
   * Identificación del elemento de moneda internacional
   *
   * *Foreign currency Id*
   *
   * @type {number} elementId
   */
  elementId: number;

  /**
   * Valor de la moneda internacional
   *
   * *Foregin currency value*
   *
   * @type {string} value
   */
  value: string;

  /**
   * Validación de selección de moneda internacional
   *
   * *Foreign currency select validation*
   *
   * @type {boolean} checked
   */
  checked: boolean;
}

/**
 * Inicialización de la clase OperationCurrencyModel, modelo de operación de la moneda
 *
 * *Set OperationCurrencyModel class, Operation currency model*
 *
 * @type {class}
 */
export class OperationCurrencyModel {
  /**
   * Descripcion de la operación de la moneda
   *
   * *Operation currency label*
   *
   * @type {string} label
   */
  label: string;

  /**
   * Nombre de la operación de la moneda
   *
   * *Operation currency name*
   *
   * @type {string} name
   */
  name: string;

  /**
   * Identificación de la operación de la moneda
   *
   * *Operation currency id*
   *
   * @type {number} id
   */
  id: number;

  /**
   * Valor de la operación de la moneda
   *
   * *Operation currency value*
   *
   * @type {number} value
   */
  value: number;

  /**
   * Validación de la operación de la moneda
   *
   * *Operation currency select validation*
   *
   * @type {boolean} checked
   */
  checked: boolean;
}

/**
 * Inicialización de la clase FinancialModel, modelo financiero
 *
 * *Set FinancialModel class, Financial's model*
 *
 * @type {class}
 */
export class FinancialModel {

  /**
  * origen de ingresos financieros
  *
  * *Financial expenses information*
  *
  * @type {number} expenses
  */
  origin?: any;

  /**
  * Información de gasto financieros
  *
  * *Financial expenses information*
  *
  * @type {number} expenses
  */
  expenses: number;

  /**
  * Información de ingresos financieros
  *
  * *Financial incomes information*
  *
  * @type {number} incomes
  */
  incomes: number;

  /**
  * Información de bienes financieros
  *
  * *Financial goods information*
  *
  * @type {number} goods
  */
  goods: number;

  /**
  * Información de deuda financiera
  *
  * *Financial debt information*
  *
  * @type {number} debt
  */
  debt: number;

  /**
  * Información de fondos financieros
  *
  * *Financial funds information*
  *
  * @type {string} funds
  */
  funds: string;

  /**
  * Información de entrada de ingresos financieros
  *
  * *Financial incomes input information*
  *
  * @type {number} incomes_input
  */
  incomes_input: number;

  /**
  * Validación de siguiente información financiera
  *
  * *Financial information next validation*
  *
  * @type {boolean} next
  */
  next: boolean;

  expensesDiscount?: number;
}

/**
 * Inicialización de la clase FinancialSecondHeadlineModel, modelo financiero segundo titular
 * 
 * *Set FinancialSecondHeadlineModel class, Second Headline Financial's model*
 * 
 * @type {class}
 */
export class FinancialSecondHeadlineModel {

  /**
  * origen de ingresos financieros
  * 
  * *Financial expenses information*
  * 
  * @type {number} expenses
  */
  origin?: any;

  /**
  * Información de gasto financieros
  * 
  * *Financial expenses information*
  * 
  * @type {number} expenses
  */
  expenses: number;

  /**
  * Información de ingresos financieros
  * 
  * *Financial incomes information*
  * 
  * @type {number} incomes
  */
  incomes: number;

  /**
  * Información de bienes financieros
  * 
  * *Financial goods information*
  * 
  * @type {number} goods
  */
  goods: number;

  /**
  * Información de deuda financiera
  * 
  * *Financial debt information*
  * 
  * @type {number} debt
  */
  debt: number;

  /**
  * Información de fondos financieros
  * 
  * *Financial funds information*
  * 
  * @type {string} funds
  */
  funds: string;

  /**
  * Información de entrada de ingresos financieros
  * 
  * *Financial incomes input information*
  * 
  * @type {number} incomes_input
  */
  incomes_input: number;

  /**
  * Validación de siguiente información financiera
  * 
  * *Financial information next validation*
  * 
  * @type {boolean} next
  */
  next: boolean;
}

/**
 * Inicialización de la clase OtherFinancialModel, modelo financiero en caso de que se tengan otros ingresos
 *
 * *Set OtherFinancialModel class, OtherFinancial's model*
 *
 * @type {class}
 */
export class OtherFinancialModel {
  /**
  * Información de entrada de otros ingresos financieros
  *
  * *Financial other incomes input information*
  *
  * @type {number} otherIncomes
  */
  otherIncomes?: number;
  /**
  * Información de otros fondos financieros
  *
  * *Financial others funds information*
  *
  * @type {string} funds
  */
  otherFunds?: string;

  otherOrigin?: any;
}

export class OtherFinancialSecondHeadlineModel {
  /**
  * Información de entrada de otros ingresos financieros
  * 
  * *Financial other incomes input information*
  * 
  * @type {number} otherIncomes
  */
  otherIncomes?: number;
  /**
  * Información de otros fondos financieros
  * 
  * *Financial others funds information*
  * 
  * @type {string} funds
  */
  otherFunds?: string;

  otherOrigin?: any;
}

/**
 * Inicialización de la clase IncomesOriginModel, modelo del origen de los ingresos
 *
 * *Set IncomesOriginModel class, Icomes origin model*
 *
 * @type {class}
 */
export class IncomesOriginModel {
  /**
   * Identificación del origen de los ingresos
   *
   * *Incomes origin identification*
   *
   * @type {boolean} next
   */
  id: string;

  /**
   * Valor del origen de los ingresos
   *
   * *Incomes origin valor*
   *
   * @type {boolean} next
   */
  value: string;
}

export class IncomesOriginSecondHeadlineModel {
  /**
   * Identificación del origen de los ingresos
   * 
   * *Incomes origin identification*
   * 
   * @type {boolean} next
   */
  id: string;

  /**
   * Valor del origen de los ingresos
   * 
   * *Incomes origin valor*
   * 
   * @type {boolean} next
   */
  value: string;
}

/**
 * Inicialización de la clase DetailAccountModel, modelo de los detalles de la cuenta
 *
 * *Set DetailAccountModel class, Detail accounts's model*
 *
 * @type {class}
 */
export class DetailAccountModel {
  /**
   * Código del estado del caso de los detalles de la cuenta
   *
   * *Account details case status code*
   *
   * @type {string} case_status_code
   */
  case_status_code: string;

  /**
   * Código nombre de los detalles de la cuenta
   *
   * *Account details name*
   *
   * @type {string} name
   */
  name: string;

  /**
   * Fecha de creación de la cuenta
   *
   * *date account creation*
   *
   * @type {string} create_date_account
   */
  create_date_account: string;

  /**
   * Tipo de cuenta
   *
   * *Account type*
   *
   * @type {string} account_type
   */
  account_type: string;

  /**
   * Número de cuenta
   *
   * *Account number*
   *
   * @type {number} account_number
   */
  account_number: number;

  /**
   * Identificación del cliente de la cuenta
   *
   * *Client account id*
   *
   * @type {string} client_id
   */
  client_id: string;

  /**
   * Código del detalle del error en la cuenta
   *
   * *Account error detail code*
   *
   * @type {string} error_detail_code
   */
  error_detail_code: string;

  /**
   * Código del detalle del error en la cuenta
   *
   * *Account error detail code*
   *
   * @type {string} error_detail_desc
   */
  error_detail_desc: string;
}

/**
 * Inicialización de la clase DetailRevolvingCreditModel, modelo de los detalles de las cuentas de credito
 *
 * *Set DetailRevolvingCreditModel class, Detail credits accounts's model*
 *
 * @type {class}
 */
export class DetailRevolvingCreditModel {
  /**
   * Código del estado del caso de los detalles de la cuenta
   *
   * *Account details case status code*
   *
   * @type {string} case_status_code
   */
  case_status_code: string;

  /**
   * Código nombre de los detalles de la cuenta
   *
   * *Account details name*
   *
   * @type {string} name
   */
  name: string;

  /**
   * Fecha de creación de la cuenta
   *
   * *date account creation*
   *
   * @type {string} create_date_account
   */
  create_date_account: string;

  /**
   * Identificación del cliente de la cuenta
   *
   * *Client account id*
   *
   * @type {string} client_id
   */
  client_id: string;

  /**
   * Número de producto
   *
   * *product_id*
   *
   * @type {string} product_id
   */
  product_id: string;

  /**
   * Tipo de producto
   *
   * *type of product*
   *
   * @type {string} client_id
   */
  product_type: string;
  /**
   * Monto aprobado
   *
   * *available amount characteristics*
   *
   * @type {object} available_amount {currency: string; amount: number; decimals: number}
   */
  available_amount: {
    currency: string;
    amount: number;
    decimals: number;
  }

  /**
   * Código del detalle del error en la cuenta
   *
   * *Account error detail code*
   *
   * @type {string} error_detail_code
   */
  error_detail_code: string;

  /**
   * Código del detalle del error en la cuenta
   *
   * *Account error detail code*
   *
   * @type {string} error_detail_desc
   */
  error_detail_desc: string;
}

/**
 * Inicialización de la clase ForeignProductsModel, modelo de los productos extrangeros
 *
 * *Set ForeignProductsModel class, foreign products model*
 *
 * @type {class}
 */
export class ForeignProductsModel {

  /**
   * Tipo de producto extrangero
   *
   * *Foreign product type*
   *
   * @type {string} product_type
   */
  product_type: string;

  /**
   * Identificación del producto extrangero
   *
   * *Foreign product id*
   *
   * @type {string} product_id
   */
  product_id: string;

  /**
   * Nombre de la entidad del producto extrangero
   *
   * *Foreign product entity name*
   *
   * @type {string} entity_name
   */
  entity_name: string;

  /**
   * Cantidad del producto extrangero
   *
   * *Foreign product amount*
   *
   * @type {string} amount
   */
  amount: string;

  /**
   * Moneda del producto extrangero
   *
   * *Foreign product currency*
   *
   * @type {string} currency
   */
  currency: string;

  /**
   * País del producto extrangero
   *
   * *Foreign product country*
   *
   * @type {CountryModel} country
   */
  country: CountryModel;


}

/**
 * Inicialización de la clase BioCatchConfigModel, modelo de BioCatchConfig
 *
 * *Set BioCatchConfigModel class, BioCatchConfig's model*
 *
 *
 * @type {class}
 */
export class BioCatchConfigModel {
  /**
   * Punto final de configuración BioCatch
   *
   * *Endpoint BioCatch configuration*
   *
   * @type {string} endpoint
   */
  endpoint: string;

  /**
   * Token de la configuración BioCatch
   *
   * *Endpoint BioCatch token*
   *
   * @type {string} token
   */
  token: string;

  /**
   * Acción de la configuración BioCatch
   *
   * *Endpoint BioCatch action*
   *
   * @type {string} action
   */
  action: string;

  /**
   * Identificación del cliente para la configuración BioCatch
   *
   * *Endpoint BioCatch customer id*
   *
   * @type {string} customerId
   */
  customerId: string;

  /**
   * Identificador único de la configuración BioCatch
   *
   * *Unique identifier of BioCatch config*
   *
   * @type {string} uuid
   */
  uuid: string;

  /**
   * Solución de la configuración BioCatch
   *
   * *Endpoint BioCatch solution*
   *
   * @type {string} solution
   */
  solution: string;

  /**
   * Url del script de la configuración BioCatch
   *
   * *Endpoint BioCatch script url*
   *
   * @type {string} scriptUrl
   */
  scriptUrl: string;

  /**
 * Url del bridge de la configuración BioCatch
 *
 * *Endpoint BioCatch bridge url*
 *
 * @type {string} bridgeUrl
 */
  bridgeUrl?: string;

  /**
 * Url del slave de la configuración BioCatch
 *
 * *Endpoint BioCatch slave url*
 *
 * @type {string} slaveUrl
 */
  slaveUrl?: string;

}

/**
 * Inicialización de la clase EmployedContractModel, modelo del contrato de empleado
 *
 * *Set EmployedContractModel class, Employed contract's model*
 *
 *
 * @type {class}
 */
export class EmployedContractModel {
  /**
   * Tipo del contrato de empleado
   *
   * Employed contract type*
   *
   * @type {TypeContractModel} typeContract
   */
  typeContract: TypeContractModel;

  /**
   * Fecha del contrato de empleado
   *
   * Employed contract date*
   *
   * @type {string} contractDate
   */
  contractDate: string;
}

/**
 * Inicialización de la clase EmployedContractSecondHeadlineModel, modelo del contrato de empleado
 * 
 * *Set EmployedContractSecondHeadlineModel class, Employed contract's model*
 * 
 * 
 * @type {class}
 */
export class EmployedContractSecondHeadlineModel {
  /**
   * Tipo del contrato de empleado
   * 
   * Employed contract type*
   * 
   * @type {TypeContractModel} typeContract
   */
  typeContract: TypeContractModel;

  /**
   * Fecha del contrato de empleado
   * 
   * Employed contract date*
   * 
   * @type {string} contractDate
   */
  contractDate: string;
}

/**
 * Inicialización de la clase TypeContractModel, modelo del tipo de contrato
 *
 * *Set TypeContractModel class, Type contract's model*
 *
 *
 * @type {class}
 */
export class TypeContractModel {

  /**
   * Descripción del tipo contrato
   *
   * *Contract type description*
   *
   * @type {string} label
   */
  label: string;

  /**
   * identificación del elemento del tipo contrato
   *
   * *Contract type element id*
   *
   * @type {number} elementId
   */
  elementId: number;

  /**
   * Validación de selección del tipo de contrato
   *
   * *Contract type select validation*
   *
   * @type {boolean} checked
   */
  checked: boolean;

  /**
   * Mensaje del tipo contrato
   *
   * *Contract type message*
   *
   * @type {string} message
   */
  message: string;

  /**
   * Tiempo (en texto) del contrato de empleado
   *
   * Employed contract time (text)*
   *
   * @type {string} timeText
   */
  timeText: string;

  /**
   * Tiempo mínimo del contrato de empleado
   *
   * Employed contract minimum time*
   *
   * @type {number} timeMin
   */
  timeMin: number;
}

/**
 * Inicialización de la clase PayDayProductModel, modelo del día de pago del producto
 *
 * *Set PayDayProductModel class, Pay day products's model*
 *
 *
 * @type {class}
 */
export class PayDayProductModel {
  /**
   * Día de pago seleccionado del producto
   *
   * *Product pay day selection*
   *
   * @type {OptionRadioModel} selectedPayDay
   */
  selectedPayDay: OptionRadioModel | any;

  /**
   * Producto seleccionado
   *
   * *Product selected*
   *
   * @type {OptionRadioModel} selectedProduct
   */
  selectedProduct: OptionRadioModel | any;
}

/**
 * Inicialización de la clase VirtualCardFranchiseModel, modelo de la franquicia para la targeta virtual
 *
 * *Set VirtualCardFranchiseModel class, franchise for the virtual card's model*
 *
 *
 * @type {class}
 */
export class VirtualCardFranchiseModel {

  /**
   * Producto seleccionado
   *
   * *Product selected*
   *
   * @type {OptionRadioModel} selectedFranchise
   */
  selectedFranchise: OptionRadioModel | any; // TODO
}

/**
 * Inicializacion de la clase LoanModel, modelo de libranza
 * 
 * *Set LoanModel class, Loan Model*
 * 
 * 
 * @type {class}
 */
export class LoanModel {
  term: number;
  amount: number;
}
export class saveValuemodel {
  savevaluemodel: number;
}

/**
 * Inicializacion de la clase selectLoan, modelo de libranza
 * 
 * *Set selectLoan class, Loan Model*
 * 
 * 
 * @type {class}
 */
export class requestselectLoan {
  elementId: string
}

/**
 * Inicialización de la clase SimulatorModel, modelo del simulador
 * 
 * *Set SimulatorModel class, Simulator Model*
 * 
 * 
 * @type {class}
 */
export class SimulatorModel {
  product_subtype: string;
  product_subline: string;
  product_name: string;
  property_amount: any;
  purchase?: number;
  creditParms?: CreditParms;
  assisted_housing_flag?: boolean | undefined;
  new_housing_flag?: boolean | undefined;
  purchase_option?: boolean | undefined;
  own_project_flag?: boolean;
  libialities: any;
  term: any;
  financing_type: any;
  available_amount: any;
  city?: any;
  fee?: any;
  leasing_contract?: any;
}

interface Interface_granted_product {
  product_type: string,
  limit_amount: {
    currency: string,
    amount: number,
    decimals: number,
  },
  term?: number,
};

interface Interface_granted_product_multi {
  brand?: string,
  product_type: string,
  limit_amount: {
    currency: string,
    amount: number,
    decimals: number,
  },
  term?: number,
};
/**
 * Inicialización de la clase BenefitsModel, modelo de PCO
 *
 * *Set BenefitsModel class, PCO's model*
 *
 *
 * @type {class}
 */
export class PcoModel {
  /**
   * Características del producto concedido
   *
   * *Granted product characteristics*
   *
   * @type {object}
   * @type {string} product_type tipo del producto
   * @type {object} limit_amount {currency: string; amount: number; decimals: number}
   * @type {number} term plazo solicitado
   */
  granted_product: Interface_granted_product;
  granted_product_multi: Interface_granted_product_multi[];
  limit_amount?: string;
  /**
   * Identificación de la solicitación del producto concedido
   *
   * *Granted product Solicitation id*
   *
   * @type {string} solicitation_id
   */
  solicitation_id: string;

  /**
   * Producto seleccionado
   *
   * *Product selected*
   *
   * @type {object} solicitation_status
   * @type {string} status_code
   * @type {string} status_description
   */
  solicitation_status: {
    status_code: string;
    status_description: string;
  };
}

/**
 * Inicialización de la clase CardTypeModel, modelo del tipo de la tarjeta
 *
 * *Set CardTypeModel class, Card type model*
 *
 *
 * @type {class}
 */
export class CardTypeModel {
  /**
   * Marca en el tipo de tarjeta
   *
   * *Cardtype brand*
   *
   * @type {string} brand
   */
  brand: string;

  /**
   * Código de la marca en el tipo de tarjeta
   *
   * *Cardtype brand code*
   *
   * @type {string} brand_code
   */
  brand_code: string;

  /**
   * Detalles de la marca en el tipo de tarjeta
   *
   * *Cardtype brand details*
   *
   * @type {string} brand_details
   */
  brand_details: string;

  /**
   * Código del producto en el tipo de tarjeta
   *
   * *Cardtype product code*
   *
   * @type {string} product_code
   */
  product_code: string;

  /**
   * Código del segmento en el tipo de tarjeta
   *
   * *Cardtype segment code*
   *
   * @type {string} segment_code
   */
  segment_code: string;

  /**
   * Parte del código del segmento en el tipo de tarjeta
   *
   * *Cardtype part segment code*
   *
   * @type {string} segment_code
   */
  part_segment_code?: string;

  /**
   * Límite máximo en el tipo de tarjeta para los valores de la moneda
   *
   * *Cardtype currency max limit*
   *
   * @type {object} max_limit {currency: string; amount: number; decimals: number}
   */
  max_limit: {
    currency: string;
    amount: number;
    decimals: number;
  };

  /**
   * Límite mínimo en el tipo de tarjeta para los valores de la moneda
   *
   * *Cardtype currency min limit*
   *
   * @type {object} max_limit {currency: string; amount: number; decimals: number}
   */
  min_limit: {
    currency: string;
    amount: number;
    decimals: number;
  };

  /**
   * Ciclo de factura en el tipo de tarjeta
   *
   * *Cardtype invoice cycle*
   *
   * @type {string} invoice_cycle_des
   */
  invoice_cycle_des: string;

  /**
   * Campaña en el tipo de tarjeta
   *
   * *Cardtype campaign*
   *
   * @type {string} campaign
   */
  campaign: string;

  /**
   * Código de campaña en el tipo de tarjeta
   *
   * *Cardtype campaign code*
   *
   * @type {string} campaign_code
   */
  campaign_code: string;

  /**
   * Canal en el tipo de tarjeta
   *
   * *Cardtype channel*
   *
   * @type {string} channel_des
   */
  channel_des: string;

  /**
   * Bin en el tipo de tarjeta
   *
   * *Cardtype bin*
   *
   * @type {string} status_code
   */
  bin: string;

  /**
   * Franquicia en el tipo de tarjeta
   *
   * *Cardtype franchise*
   *
   * @type {string} franquicia
   */
  franquicia: string;

  /**
   * Tipo de tarjeta
   *
   * *Cardtype*
   *
   * @type {string} tipo_tarjeta
   */
  tipo_tarjeta: string;

  /**
   * Fecha inicio en el tipo de tarjeta
   *
   * *Cardtype start date*
   *
   * @type {string} status_code
   */
  desde: string;

  /**
   * Fecha final en el tipo de tarjeta
   *
   * *Cardtype due date*
   *
   * @type {string} hasta
   */
  hasta: string;

  /**
   * Plan de comisión en el tipo de tarjeta
   *
   * *Cardtype comission plan*
   *
   * @type {string} plan_comision
   */
  plan_comision: string;

  /**
   * Cuota de manejo en el tipo de tarjeta
   *
   * *Cardtype handling fee*
   *
   * @type {string} couta_manejo
   */
  couta_manejo: string;

  /**
   * Periodo de exoneración en el tipo de tarjeta
   *
   * *Cardtype exemption period*
   *
   * @type {string} periodo_exoneracion
   */
  periodo_exoneracion: string;

  /**
   * Meta de facturación mensual en el tipo de tarjeta
   *
   * *Cardtype monthly billing goal*
   *
   * @type {string} meta_facturacion_mensual
   */
  meta_facturacion_mensual: string;

  /**
   * Código de segmento en el tipo de tarjeta
   *
   * *Cardtype segment code*
   *
   * @type {string} segmentCode
   */
  segmentCode: string;

  /**
   * Segmento en el tipo de tarjeta
   *
   * *Cardtype segment*
   *
   * @type {string} segment
   */
  segment: string;

  /**
   * Afinidad en el tipo de tarjeta
   *
   * *Cardtype afinity*
   *
   * @type {string} afinity
   */
  afinity: string;

  /**
   * Código de afinidad en el tipo de tarjeta
   *
   * *Cardtype afinity code*
   *
   * @type {string} afinity_code
   */
  afinity_code: string;
}

/**
 * Inicialización de la clase ProductCard, modelo de la tarjeta del producto
 *
 * *Set ProductCard class, product card's model*
 *
 *
 * @type {class}
 */
export class ProductCard {

  /**
   * Identificación de la solicitud en la tarjeta del producto
   *
   * *Product card solicitation id*
   *
   * @type {string} solicitation_id
   */
  solicitation_id: string;

  /**
   * Tipo de la solicitud en la tarjeta del producto
   *
   * *Product card solicitation type*
   *
   * @type {string} solicitation_type
   */
  solicitation_type: string;

  /**
   * Código de afinidad en el tipo de tarjeta
   *
   * *Cardtype afinity code*
   *
   * @type {object} solicitation_status {status_code: string; status_description: string; progress_precentage: number; error_code: string; error_description: string}
   */
  solicitation_status: {
    status_code: string;
    status_description: string;
    progress_percentage: number,
    error_code: string;
    error_description: string;
  };

  /**
   * Identificación del producto en la tarjeta del producto
   *
   * *Product card product id*
   *
   * @type {string} product_id
   */
  product_id: string;

  /**
   * Tipo del producto en la tarjeta del producto
   *
   * *Product card product type*
   *
   * @type {string} product_type
   */
  product_type: string;

  /**
   * Nombre del cliente en la tarjeta del producto
   *
   * *Product card client's name*
   *
   * @type {string} client_name
   */
  client_name: string;

  /**
   * Cantidad disponible en el tipo de tarjeta
   *
   * *Product card  available amount*
   *
   * @type {object} available_amount {currency: string; amount: number; decimals: string;}
   */
  available_amount: {
    currency: string;
    amount: number;
    decimals: string
  };

  /**
   * Fecha de expiración en el tipo de tarjeta
   *
   * *Product card  expiration date*
   *
   * @type {string} afinity_code
   */
  expiration_date: string;
}

/**
 * Inicialización de la clase LottieImage, modelo para formatos de imagen (librería)
 *
 * *Set LottieImage class, Image format model (Library)*
 *
 *
 * @type {class}
 */
export class LottieImage {

  /**
   * Renderización de la imagen
   *
   * *Image renderer*
   *
   * @type {string} renderer
   */
  renderer: string;

  /**
   * Validación de circuito de la imagen
   *
   * *Image loop*
   *
   * @type {boolean} afinity_code
   */
  loop: boolean;

  /**
   * Validación de reproducción automática de la imagen
   *
   * *Image autoplay*
   *
   * @type {boolean} autoplay
   */
  autoplay: boolean;

  /**
   * Información de la animación de la imagen
   *
   * *Image animation data*
   *
   * @type {string} animationData
   */
  animationData: string;
}

/**
 * Inicialización de la clase Segment, modelo del segmento
 *
 * *Set Segment class, segments's model*
 *
 *
 * @type {class}
 */
export class Segment {

  /**
   * Código del segmento
   *
   * *Segment code*
   *
   * @type {string} code
   */
  code: string;

  /**
   * Descripción del segmento
   *
   * *Segment description*
   *
   * @type {string} segment
   */
  segment: string;

  /**
   *  Descripción del subsegmento
   *
   * *Sub segment description*
   *
   * @type {string} subsegment
   */
  subsegment: string;

  /**
   *  Propiedad que determina si es un segmento valido
   *
   * *property that determine if is a valid segment*
   *
   * @type {boolean} valid
   */
  valid: boolean;
}

/**
 * Inicialización de la clase AbreCuentasModel, modelo de Abre cuentas
 *
 * *Set AbreCuentasModel class, Abre cuentas model*
 *
 *
 * @type {class}
 */

export class AbreCuentasModel {

  transaction_id: string

  transaction_status: string

  /**
   * Instancia domicilioModel como DomicilioModel, información del domicilio del usuario
   *
   * *domicilioModel instance as DomicilioModel, user's home information*
   *
   * @type {DomicilioModel} domicilioModel
   */
  domicilioModel: DomicilioModel = new DomicilioModel();

  /**
 * Define basicModel, información basica del usuario
 *
 * *basicModel declaration as IBasicModel, user's basic information*
 *
 * @type {IBasciModel} basicModel
 */
  basicModel: IBasciModel;

  /**
   * Instancia fiModel como FiModel, información del básica del usuario
   *
   * *fiModel instance as FiModel, user's basic information*
   *
   * @type {FiModel} fiModel
   */
  fiModel: FiModel = new FiModel();

  fiSecondHeadlineModel: FiModelSecondHeadline = new FiModelSecondHeadline();

  /**
   * Instancia pldModel como PldModel, información del básica del usuario
   *
   * *pldModel instance as PldModel, user's basic information*
   *
   * @type {PldModel} pldModel
   */
  pldModel: PldModel = new PldModel();

  /**
   * Modelo para las fotos del usuario
   *
   * *User's photos model*
   *
   * @type {PhotosModel} photosModel
   */
  photosModel: PhotosModel;

  /**
   * Identificación de prospect
   *
   * *Porspect id*
   *
   * @type {string} prospectId
   */
  prospectId: string;

  /**
   *  Identificación de solicitation
   *
   * *Solicitation id*
   *
   * @type {string} solicitationId
   */
  solicitationId: string;

  /**
   *  Identificación de solicitation
   *
   * *Solicitation id*
   *
   * @type {string} solicitationId
   */
  solicitationInfo: any[];

  /**
   * Parámetros para registrar
   *
   * *upload params*
   *
   * @type {any[]} uploadParams
   */
  uploadParams: any[];

  /**
   * Lista de urls
   *
   * *url list*
   *
   * @type {any[]} urlList
   */
  urlList: any[];

  /**
   * Modelo de listas
   *
   * *Lists models*
   *
   * @type {ListsModel} listsModel
   */
  listsModel: ListsModel;

  /**
   * Modelo de los términos
   *
   * *Term's model*
   *
   * @type {TermsModel} termsModel
   */
  termsModel: TermsModel;

  /**
   * Modelo de errores
   *
   * *Error model*
   *
   * @type {ErrorModel} errorModel
   */
  errorModel: ErrorModel;

  /**
   * Modelo de errores de fecha
   *
   * *Error date model*
   *
   * @type {ErrorDateModel} errorDateModel
   */
  errorDateModel: ErrorDateModel;

  /**
   *  Modelo de los documentos del usuario
   *
   * *User's documents*
   *
   * @type {DocumentModel} documentModel
   */
  documentModel: DocumentModel;
  /**
   * Modelo de la información de contácto del usuario
   *
   * *User's contact info*
   *
   * @type {ContactModel} ContactModel
   */
  ContactModel: ContactModel;

  /**
   * Modelo de LiveAbroad, información de que si el usuario vive en el exterior
   *
   * *LiveAbroad model, information to know if the user lives abroad*
   *
   * @type {LiveAbroadModel} LiveAbroadModel
   */
  LiveAbroadModel: LiveAbroadModel;
  /**
  * Modelo de Libranza
  * 
  * *Loan model*
  * 
  * @type {savevaluemodel} LoanModel
  */
  savevaluemodel: saveValuemodel;
  /**
* Modelo de Libranza
* 
* *Loan model*
* 
* @type {selectLoan} LoanModel
*/
  selectLoan: requestselectLoan;

  /**
   * Modelo de productos seleccionados internacionales
   *
   * *foreign products selection model*
   *
   * @type {LiveAbroadModel} foreignProductsSelected
   */
  foreignProductsSelected: LiveAbroadModel;

  /**
   * Modelo de información de productos internacionales
   *
   * *Foreign products information model*
   *
   * @type {ForeignProductsModel} foreignProductsInfo
   */
  foreignProductsInfo: ForeignProductsModel;

  /**
   * Modelo de lugar de nacimiento del usuario
   *
   * *Birth place information model*
   *
   * @type {CityModel} birthplaceInfo
   */
  birthplaceInfo: CityModel;

  /**
   * Modelo de país de nacimiento del usuario
   *
   * *Birth Country Infomation*
   *
   * @type {CountryModel} birthCountry
   */
  birthCountry: CountryModel;

  /**
   * Lista de ocupaciones
   *
   * *Ocupation list*
   *
   * @type {any[]} occupationList
   */
  occupationList: any[];

  /**
   * Lista de ciudades
   *
   * *City list*
   *
   * @type {any[]} cityList
   */
  cityList: any[];

  /**
   * Ocupación seleccionada por el usuario
   *
   * *User's occupation selection*
   *
   * @type {OccupationModel} occupationSelected
   */
  occupationSelected: OccupationModel;

  /**
 * Ocupación seleccionada por el usuario
 * 
 * *User's occupation selection*
 * 
 * @type {OccupationSecondHeadlineModel} occupationSelectedSecondHeadline
 */
  occupationSelectedSecondHeadline: OccupationSecondHeadlineModel;

  /**
   * Ocupación seleccionada por el usuario
   * 
   * *User's occupation selection*
   * 
   * @type {OccupationSecondHeadlineModel} occupationSelected
   */
  occupationSecondSelected: OccupationSecondHeadlineModel;

  /**
   * Modelo de ciudad de residencia del usuario
   *
   * *User's city home model*
   *
   * @type {CityModel} cityHomeModel
   */
  cityHomeModel: CityModel;

  /**
 * Modelo de estado civil del usuario
 *
 * *User's marital statul model*
 *
 * @type {MaritalStatusModel} maritalStatusModel
 */
  maritalStatusModel: MaritalStatusModel;

  /**
   * Modelo de estado civil del segundo titular
   * 
   * *User's marital statul model*
   * 
   * @type {MaritalStatusSecondHeadlineModel } maritalStatusSecondHeadLineModel
   */
  maritalStatusSecondHeadlineModel: MaritalStatusSecondHeadlineModel;


  /**
    * Modelo de segundo titular del usuario
    * 
    * *User's SecondHeadline model*
    * 
    * @type {SecondHeadline} SecondHeadline
    */
  secondHeadlineModel: SecondHeadlineModel;

  /**
    * Modelo de segundo titular del usuario
    * 
    * *User's BasicInfoSecondHeadlineModel model*
    * 
    * @type {BasicInfoSecondHeadlineModel} BasicInfoSecondHeadlineModel
    */
  basicInfoSecondHeadlineModel: BasicInfoSecondHeadlineModel;

  /**
    * Modelo de segundo titular del usuario
    * 
    * *User's ContactSecondHeadlineModel model*
    * 
    * @type {ContactSecondHeadlineModel} ContactSecondHeadlineModel
    */
  contactSecondHeadlineModel: ContactSecondHeadlineModel;

  /**
   * Modelo de seleccion de cuenta
   *
   * *User's marital statul model*
   *
   * @type {AccountSelectionModel} accountSelectionModel
   */
  accountSelectionModel: AccountSelectionModel;
  /**
* Modelo de parametros del credito solicitado
*
* *User's CreditParms model*
*
* @type {CreditParms} CreditParms
*/
  creditParms: CreditParms;

  /**
   *  Descripción del subsegmento
   *
   * *Sub segment description*
   *
   * @type {CiiuModel} ciiuModel
   */
  ciiuModel: CiiuModel;

  /**
  *  Descripción del subsegmento Segundo Titular
  * 
  * *Sub segment description*
  * 
  * @type {CiiuSecondModel} ciiuSecondModel
  */
  ciiuSecondModel: CiiuSecondModel;
  /**
   *  Descripción del subsegmento
   *
   * *Sub segment description*
   *
   * @type {string} subsegment
   */
  ciiuDate: string;

  /**
   *  Descripción del subsegmento
   *
   * *Sub segment description*
   *
   * @type {string} subsegment
   */
  ciiuSecondDate: string;
  /**
   *  Descripción del subsegmento
   * 
   * *Sub segment description*
   * 
   * @type {string} subsegment
   */
  officeModel: OfficeModel[];

  /**
   *  Descripción del subsegmento
   *
   * *Sub segment description*
   *
   * @type {string} subsegment
   */
  officeSecondHeadlineModel: OfficeSecondHeadlineModel[];

  /**
   *  Descripción del subsegmento
   * 
   * *Sub segment description*
   * 
   * @type {string} subsegment
   */
  foreignCurrencyModel: ForeignCurrencyModel;

  /**
   *  Descripción del subsegmento
   *
   * *Sub segment description*
   *
   * @type {string} subsegment
   */
  operationCurrencyModel: OperationCurrencyModel;

  /**
   *  Descripción del subsegmento
   *
   * *Sub segment description*
   *
   * @type {string} subsegment
   */
  benefitsList: string[];

  /**
   * Lista de actividades económicas para selección del usuario
   *
   * *Economical activities list for user's selection*
   *
   * @type {any[]} ciiuList
   */
  ciiuList: any[];

  /**
   * Lista de operación de moneda para selección del usuario
   *
   * *Operation currency list for user's selection*
   *
   * @type {string} subsegment
   */
  operationCurrencyList: any[];

  /**
   * Intentos para escanear la parte posterior del documento
   *
   * *Back document ascan attempts*
   *
   * @type {number} backDocumentScanAttempts
   */
  backDocumentScanAttempts: number;

  /**
   * Intentos para escanear la parte frontal del documento
   *
   * *front document ascan attempts*
   *
   * @type {number} subsegment
   */
  frontDocumentScanAttempts: number;

  /**
   * Intentos para escanear huellas digitales del usuario
   *
   * *figer print scan attempts*
   *
   * @type {number} fingerPrintsScanAttempts
   */
  fingerPrintsScanAttempts: number;

  /**
   * Validación de selección de información de ingresos
   *
   * *User's incomes checkbox select validation*
   *
   * @type {CheckboxModel} checkboxInfoIncomesChecked
   */
  checkboxInfoIncomesChecked: CheckboxModel;

  /**
   * Información de los ingresos inferidos
   *
   * *User's inferred incomes information*
   *
   * @type {any} infoInferredIncomes
   */
  infoInferredIncomes: any;

  /**
   * Información de la dirección ip
   *
   * *IP address information*
   *
   * @type {string} infoIp
   */
  infoIp: string;

  /**
   * Modelo de lista de acuerdos
   *
   * *Agreement list model*
   *
   * @type {AgreementsModel[]} agreementList
   */
  agreementList: AgreementsModel[];

  /**
   * Modelo de busqueda de ciudad seleccionada
   *
   * *User's selected city search model*
   *
   * @type {CityModel} citySearchSelected
   */
  citySearchSelected: CityModel;

  /**
   * Modelo de busqueda de origen de ingresos de usuario
   *
   * *Incomes origin search selected model*
   *
   * @type {string} subsegment
   */
  incomesOriginSearchSelected: IncomesOriginModel;

  incomesOriginSecondHeadlineSelected: IncomesOriginSecondHeadlineModel;
  /**
   * Modelo de agencia seleccionada
   *
   * *Agency selected model*
   *
   * @type {string} subsegment
   */
  agencySelected: AgencyModel;

  disbursementAgencySelected: AgencyModel;

  /**
   * Configuración Bytte para el escaneo de imagenes
   *
   * *Bytte configuration for images scanning*
   *
   * @type {BytteConfigType} bytteConfig
   */
  bytteConfig: BytteConfigType;

  /**
   * Capa de seguriad de la aplicación a nivel del dispositivo
   *
   * *App security layer at device layer*
   *
   * @type {DSBMobileConfig} dsbMobileCofig
   */
  dsbMobileCofig: DSBMobileConfig;

  /**
   * configuración de validación de excepción de seguridad
   *
   * *dsb security check exception*
   *
   * @type {string} dsbSecurityCheckException
   */
  dsbSecurityCheckException: string;

  /**
   * Modelo de producto seleccionado
   *
   * *Selected product model*
   *
   * @type {string} productSelected
   */
  productSelected: IProductsModel;

  /**
   * Configuración de abre cuentas (app)
   *
   * *Abrecuentas app config*
   *
   * @type {object} abreCuentasConfigs {[id: string]: any}
   */
  abreCuentasConfigs: { [id: string]: any };

  businessConfigMap: {
    [id: string]
    : any;
  };

  /**
   * Modelo financiero
   *
   * *Fianncial model*
   *
   * @type {FinancialModel} financialModel
   */
  financialModel: FinancialModel;

  /**
   * Modelo financiero para segundo titular
   * 
   * *Financial second headline model*
   * 
   * @type {FinancialMoFinancialSecondHeadlineModeldel} financialSecondHeadlineModel
   */
  financialSecondHeadlineModel: FinancialSecondHeadlineModel;
  /**
   * Modelo otrs ingresos financiero
   *
   * *Fianncial other incomes model*
   *
   * @type {OtherFinancialModel} otherFinancialModel
   */
  otherFinancialModel: OtherFinancialModel;

  /**
   * Modelo otrs ingresos financiero
   * 
   * *Fianncial other incomes model*
   * 
   * @type {OtherFinancialSecondHeadlineModel} otherFinancialSecondHeadlineModel
   */
  otherFinancialSecondHeadlineModel: OtherFinancialSecondHeadlineModel;
  /**
   * Modelo de los detalles de la cuenta del usuario
   *
   * *User's detail account model*
   *
   * @type {DetailAccountModel} detailAccountModel
   */
  detailAccountModel: DetailAccountModel;

  /**
   * Modelo de los detalles del credito aprovado del usuario
   *
   * *User's detail account credit aprove model*
   *
   * @type {DetailRevolvingCreditModel} DetailRevolvingCreditModel
   */
  detailRevolvingCreditModel: DetailRevolvingCreditModel;

  /**
   * Configuración biocatch, capa de seguridad de la aplicación a nivel de la webview
   *
   * *Bio catch configuration, app security layer at webview level*
   *
   * @type {BioCatchConfigModel} biocatchConfig
   */
  biocatchConfig: BioCatchConfigModel;

  /**
   * Modelo de contratos de empleado
   *
   * *Employed contract model*
   *
   * @type {EmployedContractModel} employedContractModel
   */
  employedContractModel: EmployedContractModel;

  /**
   * Modelo de contratos de empleado
   * 
   * *Employed contract model*
   * 
   * @type {EmployedContractSecondHeadlineModel} employedContractSecondHeadlineModel
   */
  employedContractSecondHeadlineModel: EmployedContractSecondHeadlineModel;

  /**
   * Modelo de Información del dispositivo del usuario
   *
   * *User's device info configuration*
   *
   * @type {LogDeviceModel} deviceInfo
   */
  deviceInfo: LogDeviceModel;

  /**
   * Modelo de acuerdos seleccionados
   *
   * *Agreement selected model*
   *
   * @type {AgreementsModel} agreementSelected
   */
  agreementSelected: AgreementsModel;

  /**
   * Modelo del día de pago del producto
   *
   * *Pay day product model*
   *
   * @type {PayDayProductModel} paydayProductModel
   */
  paydayProductModel: PayDayProductModel;

  /**
   * Modelo del día de pago del producto
   *
   * *Pay day product model*
   *
   * @type {VirtualCardFranchiseModel} virtualCardFranchiseModel
   */
  virtualCardFranchiseModel: VirtualCardFranchiseModel;

  /**
   * Modelo de dirección de contacto del usuario
   *
   * *User's adress contact model*
   *
   * @type {AddressModel} contactAdressConfigTc
   */
  contactAdressConfigTc: AddressModel;

  /**
   * List de modelo de dirección para guardar las direcciones del usuario
   * *User's adress list contact model*
   *
   * @type {AddressModel} contactAdressConfigTc
   */
  addressTcConfigList: any[];

  /**
   * Respuesta de prospect
   *
   * *Porspect response*
   *
   * @type {any} ProspectResponse
   */
  ProspectResponse: any;
  /**
   * Respuesta de prospect
   *
   * *Porspect response*
   *
   * @type {any} ProspectResponseSecondHeadLine
   */
  ProspectResponseSecondHeadLine: any;

  /**
   * Modelo de método de envío
   *
   * *Selected shipping method model*
   *
   * @type {ObjectCheckModel} selectedShippingMethod
   */
  selectedShippingMethod: ObjectCheckModel;

  /**
  * Información del cliente
  *
  * *Custormer data*
  *
  * @type {any} customerData
  */
  customerData: any;

  /**
   * Monto de PCO aprovado
   *
   * *PCO aproved amount*
   *
   * @type {number} subsegment
   */
  amountPcoAproved: number;

  /**
   * Modelo de PCO
   *
   * *PCO model*
   *
   * @type {PcoModel} pcoModel
   */
  pcoModel: PcoModel;

  /**
   * Modelo de PCO para Multiproduct
   *
   * *PCO model for Multiproduct*
   *
   * @type {PcoModel[]} pcoModel
   */
  pcoModelMulti: PcoModel[];

  /**
   * Modelo de Simulador
   * 
   * *Simulator model*
   * 
   * @type {SimulatorModel} SimulatorModel
   */
  simulatorModel: SimulatorModel;

  /**
  * Modelo de Libranza
  * 
  * *Loan model*
  * 
  * @type {LoanModel} LoanModel
  */
  loanModel: LoanModel;

  /**
   * Modelo de tipo de tarjeta
   *
   * *Card type model*
   *
   * @type {CardTypeModel} cardType
   */
  cardType: CardTypeModel;

  /**
   * Modelos de tipos de tarjetas
   *
   * *Card type model*
   *
   * @type {CardTypeModel} cardType
   */
  cardTypes: any;

  /**
   * Tarjeta del producto
   *
   * *Product card*
   *
   * @type {ProductCard} productCard
   */
  productCard: ProductCard;

  /**
   * Modelo de información de la aplicación
   *
   * *App info model*
   *
   * @type {AppInfoModel} appInfo
   */
  appInfo: AppInfoModel;

  /**
   * Modelo de la información del dispositivo del usuario
   *
   * *User's device information model*
   *
   * @type {DeviceInfoModel} deviceInfoModel
   */
  deviceInfoModel: DeviceInfoModel;

  /**
   * Modelo de la información del dispositivo del usuario
   *
   * 
   *
   * @type {TransactionInfoModel} transactionInfoModel
   */
  transactionInfoModel: TransactionInfoModel;


  /**
   * Validacipon de lectura del servicio del cliente
   *
   * *Read customer service validation*
   *
   * @type {boolean} readCustomerService
   */
  readCustomerService: boolean;

  /**
  * Validacipon del flujo por el que se ecnuentra el usuario
  *
  * *Read type flow for user*
  *
  * @type {boolean} readCustomerService
  */
  isPostlogin: boolean;

  /**
   * Validación de muestra de mensaje de actualización
   *
   * *Show message update validation*
   *
   * @type {boolean} showMessageUpdate
   */
  showMessageUpdate: boolean;

  /**
   * Validación de actualización del cliente
   *
   * *UPdate client validation*
   *
   * @type {boolean} updateClient
   */
  updateClient: boolean;

  /**
   * Error de imagen Lottie
   *
   * *imageLottie Error*
   *
   * @type {LottieImage} imageLottieError
   */
  imageLottieError: LottieImage;

  /**
   * Tarjeta de recepción
   *
   * *Received card*
   *
   * @type {string} receiveCard
   */
  receiveCard: string;

  advisorCheck: string;

  flowStructure: any[];

  multiproductFlowUpdate: {};

  /**
   * Validación de actualización del correo
   *
   * *Update mail validation*
   *
   * @type {boolean} updateMail
   */
  updateMail: boolean;

  /**
   * Validación de actualización del teléfono
   *
   * *Update phone validation*
   *
   * @type {boolean} updatePhone
   */
  updatePhone: boolean;


  /**
   * Validación de fecha de pago
   *
   * *Update pay day*
   *
   * @type {string} Day of pay
   */
  payDay: string | null;

  advisorCode: string | null;
  /**
   * Validacipon si el cliente existente tiene o no un producto
   *
   *
   * @type {boolean} readCustomerService
   */
  isclientProduct: boolean;
  /**
   * lista de productos asiciados al cliente
   *
   *
   * @type {any} readCustomerService
   */
  listclientProduct: [any];
  /**
   * Modelo de producto cliente
   *
   * *Selected client product model*
   *
   * @type {string} ClientProductModel
   */
  createProduct: ClientProductModel;

  appLoaded: boolean = false;

  isPortal: boolean = false;

  CSID: string;

  PPID: string;

  ipAddress: string;
  channelNot_SolicitationId: any[];
  /**
   *  valores indicados por el usuario para cada una de las tarcejas.
   *  Configuration_Values
   *  value_mater :number;
   *  value_visa :number;
   *  value_visalf :number;
   */
  configValuesModel: ConfigValuesModel;

  otherSimulationData: OtherSimulationDataModel;
  otherEvidenteDataModel: OtherEvidenteDataModel;
  agreementDetail: DetailAgreement;
  ethnicGroupInfo: EthnicGroupModel;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   * *Initialize method for models*
   *
   * @var {string}                 solicitationId                               Sets variable as empty
   * @var {PhotosModel}            photosModel                                  Sets variable as new PhotosModel
   * @var {ListsModel}             listsModel                                   Sets variable as new ListsModel
   * @var {TermsModel}             termsModel                                   Sets variable as new TermsModel
   * @var {SystemInfoModel}        systemInfoModel                              Sets variable as new SystemInfoModel
   * @var {ErrorModel}             errorModel                                   Sets variable as new ErrorModel
   * @var {ErrorDateModel}         errorDateModel                               Sets variable as new ErrorDateModel
   * @var {DocumentModel }         documentModel  
   *                                  Sets variable as new DocumentModel
   * @var {ContactModel}           ContactModel                                 Sets variable as new ContactModel
   * @var {BytteConfigType}        bytteConfig                                  Sets variable as new BytteConfigType
   * @var {DSBMobileConfig}        dsbMobileCofig                               Sets variable as new DSBMobileConfig
   * @var {saveValuemodel}              saveValuemodel                          Sets variable as new saveValuemodel
   * @var {selectLoan}             selectLoan                                   Sets variable as new selectLoan
   * @var {DocumentModel}          documentModel
   * @var {LiveAbroadModel}        LiveAbroadModel                              Sets variable as new LiveAbroadModel
   * @var {ForeignCurrencyModel}   foreignCurrencyModel                         Sets variable as new ForeignCurrencyModel
   * @var {OperationCurrencyModel} operationCurrencyModel                       Sets variable as new OperationCurrencyModel
   * @var {OccupationModel}        occupationSelected                           Sets variable as new OccupationModel
   * @var {OccupationSecondHeadlineModel}  occupationSelectedSecondHeadline     Sets variable as new OccupationSecondHeadlineModel
   * @var {LiveAbroadModel}        foreignProductsSelected                      Sets variable as new LiveAbroadModel
   * @var {CityModel}              cityHomeModel                                Sets variable as new CityModel
   * @var {EthnicGroupModell}      ethnicGroupModel                             Sets variable as new MaritalStatus
   * @var {MaritalStatusModel}     maritalStatusModel                           Sets variable as new MaritalStatus
   * @var {Array<OfficeModel>}     officeModel                                  Sets variable as new Array<OfficeModel>
   * @var {Array<OfficeSecondHeadlineModel>}     officeSecondHeadlineModel      Sets variable as new Array<OfficeSecondHeadlineModel>
   * @var {ForeignProductsModel}   foreignProductsInfo                          Sets variable as new ForeignProductsModel
   * @var {CiiuModel}              ciiuModel                                    Sets variable as new CiiuModel
   * @var {CiiuSecondModel}        ciiuSecondModel                              Sets variable as new CiiuSecondModel
   * @var {string}                 ciiuDate                                     Sets variable as empty
   * @var {CheckboxModel}          checkboxInfoIncomesChecked                   Sets variable as new CheckboxModel
   * @var {number}                 backDocumentScanAttempts                     Sets variable as 0
   * @var {number}                 frontDocumentScanAttempts                    Sets variable as 0
   * @var {number}                 fingerPrintsScanAttempts                     Sets variable as 0
   * @var {object}                 businessConfigMap                            Sets variable as empty object {}
   * @var {FinancialModel}         financialModel                               Sets variable as new FinancialModel
   * @var {FinancialSecondHeadlineModel}         financialSecondHeadlineModel                               Sets variable as new FinancialSecondHeadlineModel
   * @var {OtherFinancialModel}    otherFinancialModel                          Sets variable as new OtherFinancialModel
   * @var {OtherFinancialSecondHeadlineModel}    otherFinancialSecondHeadlineModel                          Sets variable as new OtherFinancialSecondHeadlineModel
   * @var {string}                 dsbSecurityCheckException                    Sets variable as '0000'
   * @var {CityModel}              citySearchSelected                           Sets variable as new CityModel
   * @var {IncomesOriginModel}     incomesOriginSearchSelected                  Sets variable as new IncomesOriginModel
   * @var {IncomesOriginSecondHeadlineModel}     incomesOriginSecondHeadlineSelected                  Sets variable as new IncomesOriginSecondHeadlineModel
   * @var {AgencyModel}            agencySelected                               Sets variable as new AgencyModel
   * @var {CityModel}              birthplaceInfo                               Sets variable as new CityModel
   * @var {BioCatchConfigModel}    biocatchConfig                               Sets variable as new BioCatchConfigModel
   * @var {string}                 sessionId                                    Sets variable as empty
   * @var {EmployedContracSecondHeadlinetModel}  employedContractSecondHeadlineModel          Sets variable as new EmployedContracSecondHeadlinetModel
   * @var {string}                 employedContractSecondHeadlineModel.contractDate           Sets variable as empty
   * @var {TypeContractModel}      employedContractSecondHeadlineModel.typeContract           Sets variable as new TypeContractModel
   * @var {number}                 employedContractSecondHeadlineModel.typeContract.elementId Sets variable as 0  
   * @var {EmployedContractModel}  employedContractModel                        Sets variable as new EmployedContractModel
   * @var {string}                 employedContractModel.contractDate           Sets variable as empty
   * @var {TypeContractModel}      employedContractModel.typeContract           Sets variable as new TypeContractModel
   * @var {number}                 employedContractModel.typeContract.elementId Sets variable as 0
   * @var {CreditParms}            creditParms                                  Sets variable as new creditParms
   * @var {LogDeviceModel}         deviceInfo                                   Sets variable as new LogDeviceModel
   * @var {PayDayProductModel}     paydayProductModel                           Sets variable as new PayDayProductModel
   * @var {AddressModel}           contactAdressConfigTc                        Sets variable as new AddressModel
   * @var {number}                 amountPcoAproved                             Sets variable as 0
   * @var {PcoModel}               pcoModel                                     Sets variable as new PcoModel
   * @var {SimulatorModel}         simulatorModel                               Sets variable as new SimulatorModel
   * @var {LoanModel}              loanModel                                    Sets variable as new LoanModel
   * @var {CardTypeModel}          cardType                                     Sets variable as new CardTypeModel
   * @var {any}                    cardTypes                                    Sets variable as new any
   * @var {ProductCard}            productCard                                  Sets variable as new ProductCard
   * @var {AppInfoModel}           appInfo                                      Sets variable as new AppInfoModel
   * @var {AppInfoModel}           deviceInfoModel                              Sets variable as new AppInfoModel
   * @var {AppInfoModel}           transactionInfoModel                         Sets variable as new AppInfoModel
   * @var {boolean}                readCustomerService                          Sets variable as false
   * @var {boolean}                showMessageUpdate                            Sets variable as false
   * @var {boolean}                updateClient                                 Sets variable as false
   * @var {object}                 agreementSelected                            Sets object as {agreement_code: '0', agreement_name: '', agreement_id: '', transaction_type: 'false', description: '', row_id: '', }
   * @var {object}                 imageLottieError                             Sets object as { renderer: 'svg', loop: true, autoplay: true, animationData: '', }
   * @var {string}                 receiveCard                                  Sets variable as empty
   * @var {boolean}                updateMail                                   Sets variable as false
   * @var {boolean}                updatePhone                                  Sets variable as false
   * @var {boolean}                payDay                                       Sets variable as null
   * @var {string}                 advisorCode                                  Sets variable as string
   * @var {string}                 advisorCheck                                 Sets variable as empty
   * @var {AccountSelectionModel}  accountSelectionModel                        Sets variable as new AccountSelectionModel
   *
   */
  constructor() {

    this.solicitationId = '';
    this.photosModel = new PhotosModel();
    this.listsModel = new ListsModel();
    this.termsModel = new TermsModel();
    this.errorModel = new ErrorModel();
    this.creditParms = new CreditParms();
    this.errorDateModel = new ErrorDateModel();
    this.documentModel = new DocumentModel();
    this.savevaluemodel = new saveValuemodel();
    this.selectLoan = new requestselectLoan();
    this.ContactModel = new ContactModel();
    this.bytteConfig = new BytteConfigType();
    this.dsbMobileCofig = new DSBMobileConfig();
    this.documentModel = new DocumentModel();
    this.LiveAbroadModel = new LiveAbroadModel();
    this.foreignCurrencyModel = new ForeignCurrencyModel();
    this.operationCurrencyModel = new OperationCurrencyModel();
    this.occupationSelected = new OccupationModel();
    this.occupationSelectedSecondHeadline = new OccupationSecondHeadlineModel();
    this.foreignProductsSelected = new LiveAbroadModel();
    this.cityHomeModel = new CityModel();
    this.maritalStatusModel = new MaritalStatusModel();
    this.accountSelectionModel = new AccountSelectionModel();
    this.officeModel = new Array<OfficeModel>();
    this.officeSecondHeadlineModel = new Array<OfficeSecondHeadlineModel>();
    this.foreignProductsInfo = new ForeignProductsModel();
    this.ciiuModel = new CiiuModel();
    this.ciiuSecondModel = new CiiuSecondModel();
    this.ciiuDate = '';
    this.checkboxInfoIncomesChecked = new CheckboxModel();
    this.backDocumentScanAttempts = 0;
    this.frontDocumentScanAttempts = 0;
    this.fingerPrintsScanAttempts = 0;
    this.financialModel = new FinancialModel();
    this.financialSecondHeadlineModel = new FinancialSecondHeadlineModel();
    this.otherFinancialModel = new OtherFinancialModel();
    this.otherFinancialSecondHeadlineModel = new OtherFinancialSecondHeadlineModel();
    this.dsbSecurityCheckException = '0000';
    this.citySearchSelected = new CityModel();
    this.businessConfigMap = {};
    this.incomesOriginSearchSelected = new IncomesOriginModel();
    this.incomesOriginSecondHeadlineSelected = new IncomesOriginSecondHeadlineModel;
    this.agencySelected = new AgencyModel();
    this.birthplaceInfo = new CityModel();
    this.ethnicGroupInfo = new EthnicGroupModel();
    this.biocatchConfig = new BioCatchConfigModel();
    this.employedContractSecondHeadlineModel = new EmployedContractSecondHeadlineModel();
    this.employedContractSecondHeadlineModel.contractDate = '';
    this.employedContractSecondHeadlineModel.typeContract = new TypeContractModel();
    this.employedContractSecondHeadlineModel.typeContract.elementId = 0;
    this.employedContractModel = new EmployedContractModel();
    this.employedContractModel.contractDate = '';
    this.employedContractModel.typeContract = new TypeContractModel();
    this.employedContractModel.typeContract.elementId = 0;
    this.deviceInfo = new LogDeviceModel();
    this.paydayProductModel = new PayDayProductModel();
    this.virtualCardFranchiseModel = new VirtualCardFranchiseModel();
    this.amountPcoAproved = 0;
    this.pcoModel = new PcoModel();
    this.simulatorModel = new SimulatorModel();
    this.loanModel = new LoanModel();
    this.cardType = new CardTypeModel();
    this.cardTypes = {};
    this.productCard = new ProductCard();
    this.appInfo = new AppInfoModel();
    this.deviceInfoModel = new DeviceInfoModel();
    this.transactionInfoModel = new TransactionInfoModel();
    this.otherSimulationData = new OtherSimulationDataModel();
    this.readCustomerService = false;
    this.showMessageUpdate = false;
    this.updateClient = false;
    this.agreementSelected = {
      agreement_code: '0',
      agreement_name: '',
      agreement_id: '',
      transaction_type: 'false',
      description: '',
      row_id: '',
      document_number: '',
      client_name: '',
    };
    this.imageLottieError = {
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: '',
    };
    this.receiveCard = '';
    this.updateMail = false;
    this.updatePhone = false;
    this.payDay = null;
    this.advisorCode = null;
    this.advisorCheck = '';
    this.appLoaded = false;
    this.isPortal = false;
    this.CSID = '';
    this.agreementDetail;
    this.configValuesModel = new ConfigValuesModel()
  }
}